// Defined via layers

export default defineAppConfig({});
